import './main.css';
import Navbar from "./components/Navbar";
import Blogs from './pages/Blogs';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BlogDetail from './pages/BlogDetail';

function App() {
    return (
        <BrowserRouter>
            <Navbar />
            <Routes>
                <Route path='/' element={<Blogs />} />
                <Route path='/blogs/:blogId' element={<BlogDetail />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
